export default "__VITE_ASSET__DeBT7qze__"